module.exports = __webpack_public_path__ + "static/media/profile.ffa19cb8.svg";